;(function( $ ) {
	'use strict';
	let mobileWidth   = 1000;
	let taggedHistory = (function() {
			// Tag the place we come in on, so we know when we get back here.
			if ( typeof (window.history.replaceState) === 'function' ) {
				window.history.replaceState( { page: 1, href: location.href }, document.title );
				return true;
			}

			return false;
		}()),
		closeOverlay  = function() {
			// Send the focus back to the menu item that got us here.
			$( document ).find( 'a[href="' + window.location.hash + '"]' ).first().focus();

			// Check if we're trying to close on the first page in the history
			if ( !taggedHistory || window.history.state && window.history.state.page === 1 ) {
				window.location.hash = '';
			}
			// Most of the time we'll just be using the history object to go back.
			else {
				window.history.go( -1 );
			}
		},
		$body         = $( 'body' ),
		stopScrolls   = function() {
			if ( window.location.hash === '#navigation' && $( window ).width() < mobileWidth ) {
				$body.addClass( 'no-scroll' );
			}
			else {
				$body.removeClass( 'no-scroll' );
			}
		},
		$subNav       = $( '.primary-nav li.menu-item-has-children' );

	// Clicking the overlay close
	$( document ).on( 'click', '.ol-close.iconned', function( e ) {
		e.preventDefault( e );
		closeOverlay();
	} );

	$subNav.on( 'click', '> a', function( e ) {
		let $this = $( this );

		if ( window.matchMedia( '(max-width: ' + (mobileWidth - 1).toString() + 'px)' ).matches || $this.attr( 'href' ).match( /^#/ ) ) {
			e.preventDefault( e );
		}

		if ( !$this.parent().hasClass( 'active' ) ) {
			$subNav.not( $this ).removeClass( 'active' );
			$this.parent().addClass( 'active' );
		}
		else {
			$this.parent().removeClass( 'active' );
		}
	} );

	$( window ).on( 'hashchange', stopScrolls );

	$( window ).on( 'resize', function() {
		if ( $( this ).width() >= mobileWidth ) {
			closeOverlay();
		}
	} );

	// Close the overlays using the ESC key
	$( document ).on( 'keyup', function( e ) {
		if ( e.keyCode === 27 && (window.location.hash === '#navigation' || window.location.hash === '#login' || window.location.hash === '#search') ) {
			closeOverlay();
		}
	} );
}( jQuery ));
